export const SURVEY_RESPONSE_MODULES = ["messaging.surveys", "messaging.messages", "messaging.guests", "operations.surveys"];
export const canReadSurveyResponse = (canView) => SURVEY_RESPONSE_MODULES.some(canView);
